import React from 'react';
import {useChatContext} from "./ChatContext";

export function Overlay(): React.ReactElement {
    const { chat } = useChatContext();

    return (
        <div id="wvcb__overlay" onClick={chat.close}></div>
    );
};
